export const isJsDom = () => {
  return (
    // https://github.com/jsdom/jsdom/issues/1537
    navigator.userAgent.includes('Node.js') ||
    navigator.userAgent.includes('jsdom')
  )
}
